<div class="login-container">
  <div class="login-panel">
    <!-- LOGIN HEADER - Common to both flows -->
    <div class="login-header">
      <svg-icon class="logo" src="assets/icons/gains-logo.svg"></svg-icon>
      <h1 class="login-title">Welcome Back!</h1>
    </div>

    <sso-login></sso-login>

    <!-- LOGIN FOOTER - Common to both flows -->
    <div class="login-footer">
      <div class="version-info">
        <svg-icon class="supply-chain-logo" src="assets/icons/supply-chain.svg"></svg-icon>
        {{ gainsVersion }}
      </div>
      <svg-icon class="supply-chain-logo" src="assets/icons/bottom.svg"></svg-icon>
    </div>
  </div>

  <!-- RIGHT PANEL - Always visible -->
  <div class="right-panel">
    <div class="supply-chain-card">
      <div class="supply-chain-header">
        <h2 class="supply-chain-title">SUPPLY CHAIN</h2>
        <button type="button" class="learn-more-button">Learn more</button>
      </div>

      <div class="supply-chain-visual-frame">
        <div class="supply-chain-visual">
          <svg-icon class="center-cloud" src="assets/icons/login-white-icons/cloud.svg"></svg-icon>

          <svg-icon class="orbit-icon icon-top" src="assets/icons/login-white-icons/rocket.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-top-right" src="assets/icons/login-white-icons/arrows-spin.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-middle-right" src="assets/icons/login-white-icons/chart-stacked-area.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-bottom-right" src="assets/icons/login-white-icons/hammer-2.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-bottom" src="assets/icons/login-white-icons/users-2.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-bottom-left" src="assets/icons/login-white-icons/database.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-middle-left" src="assets/icons/login-white-icons/gaming-blocks.svg"></svg-icon>
          <svg-icon class="orbit-icon icon-top-left" src="assets/icons/login-white-icons/box.svg"></svg-icon>
        </div>
      </div>

      <div class="supply-chain-content">
        <h3>Cloud-native solution</h3>
        <p>The solution is entirely based in the cloud, allowing for seamless collaboration and enhanced accessibility.</p>
      </div>
    </div>
  </div>
</div>
